import i18n from '@/i18n'
import { watch } from 'vue'
import store from '@/store'
import zhLocale from '@/i18n/lang/zh'

export function generateTitle (title) {
  // return i18n.global.t('msg.route.' + title)

  // 如果国际化无法获取到正确的翻译，则直接从中文语言包中获取
  const translation = i18n.global.t('msg.route.' + title)

  // 如果翻译结果与原始键相同（表示没找到翻译），则直接从中文语言包获取
  if (translation === 'msg.route.' + title) {
    return zhLocale.route[title] || title
  }
  if (translation === 'msg.tagsView.' + title) {
    return zhLocale.tagsView[title] || title
  }
}

/**
 * 监听语言的变化，同时 执行 参数方法
 */
export function watchSwitchLang (...cbs) {
  watch(
    () => store.getters.language,
    () => {
      cbs.forEach(cb => cb(store.getters.language))
    }
  )
}
